import './styles/gallery.content.css';
import { useState } from 'react';
import ImageModal from './ImageModal';
const pageTitles = ["냉장고", "제빙기", "쇼케이스"];





export default function GalleryContent({ imagePages, page }) {
  const [selected, setSelected] = useState(null);
  if (!Array.isArray(imagePages) || !imagePages[page]) {
    return null;
  }
  return (
    <>
       <div className="gallery-title">
        {pageTitles[page]}
      </div>

      <div className="image-grid">
        {imagePages[page].map((img, idx) => (
          <div
            className="image-box"
            key={idx}
            onClick={() => setSelected(img)}
          >
            <img src={img.src} alt="" />
          </div>
        ))}
      </div>

      <ImageModal data={selected} onClose={() => setSelected(null)} />
    </>
  );
}